import { createContext } from "react";
import type { inferRouterOutputs } from "@trpc/server";
import type { AppRouter } from "@api-types/routers/routers";

type AuthSession = inferRouterOutputs<AppRouter>["auth"]["getSession"];

type SessionPermissionEntry = NonNullable<AuthSession>["permissions"][number];
export type SessionPermissionId = SessionPermissionEntry["permissionId"];

export type AuthContextValue = {
  session?: AuthSession;
  isLogged: boolean;
  isFetching: boolean;
  isError: boolean;
  refresh: () => Promise<void>;
  hasPermission: (permission: SessionPermissionId) => boolean;
  hasGlobalPermission: (permission: SessionPermissionId) => boolean;
  hasPermissionForBrand: (permission: SessionPermissionId, brandId: string, agencyId: string | null) => boolean;
  hasPermissionForAgency: (permission: SessionPermissionId, agencyId: string) => boolean;
  hasPermissionForCreatorNetwork: (permission: SessionPermissionId, creatorNetworkId: string) => boolean;
};

export const authContextDefaultValue: AuthContextValue = {
  session: undefined,
  isLogged: false,
  isFetching: false,
  isError: false,
  refresh: async () => {
    /* noop */
  },
  hasPermission: () => false,
  hasGlobalPermission: () => false,
  hasPermissionForBrand: () => false,
  hasPermissionForAgency: () => false,
  hasPermissionForCreatorNetwork: () => false,
};

export const AuthContext = createContext<AuthContextValue>(authContextDefaultValue);
